import { z } from 'zod';

export const ChangePasswordFormSchema = z.object({
	confirmPassword: z.string().min(6, 'Confirm Password must be at least 6 characters long'),
	currentPassword: z.string(),
	newPassword:     z.string().min(6, 'New Password must be at least 6 characters long'),
});
export type ChangePasswordFormModel = z.infer<typeof ChangePasswordFormSchema>;
